<div class="min-vh-100 d-flex flex-column">
  <header>
    <nz-navbar/>
  </header>
  <main class="flex-grow-1 d-flex flex-column position-relative" role="main">
    <router-outlet/>
  </main>
  <footer>
    <nz-footer/>
  </footer>
</div>
<nz-image-viewer/>
<nz-scroll-top-button/>
